import { styled } from '../../../Utilities';
import { ShimmerLineBase } from './ShimmerLine.base';
import { getStyles } from './ShimmerLine.styles';
export var ShimmerLine = styled(ShimmerLineBase, getStyles, undefined, {
    scope: 'ShimmerLine'
});
//# sourceMappingURL=ShimmerLine.js.map